import { render, staticRenderFns } from "./scan-code.vue?vue&type=template&id=1fa04521&scoped=true&"
import script from "./scan-code.vue?vue&type=script&lang=js&"
export * from "./scan-code.vue?vue&type=script&lang=js&"
import style0 from "./scan-code.vue?vue&type=style&index=0&id=1fa04521&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fa04521",
  null
  
)

export default component.exports